import { ApiResponse } from "../types/api-response";
import { TopFilterOutput } from "./useTopFilter";
import useAuth from "./useAuth";
import useSWR from "swr";
import { PaginationQuery } from "./useAlerts";

export interface KLHKResponse {
  uuid: string;
  area: string;
  parameter: string;
  description: string;
  completion_date: string;
  file: string;
  status: string;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  mil: Mil;
  cem: Cem;
  ncr_klhk_status_history: NcrKlhkStatusHistory[];
}

interface Mil {
  uuid: string;
  name: string;
}

interface Cem {
  uuid: string;
  name: string;
}

interface NcrKlhkStatusHistory {
  uuid: string;
  status: string;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  created_by: CreatedBy;
}

interface CreatedBy {
  uuid: string;
  name: string;
  email: string;
  role: string;
}

interface ResponseInterface {
  meta: {
    page: number;
    last_page: number;
    length: number;
    total_data: number;
  };
  data: KLHKResponse[];
}

const useAllKlhk = (filter: TopFilterOutput & PaginationQuery) => {
  const { _type, time, page, limit, ...data } = filter;
  const url = `/ncr-klhk/${_type}?page=${page}&limit=${limit}`;
  const { fetcher } = useAuth();
  const output = useSWR([url, JSON.stringify(data)], (url, param) =>
    fetcher()
      .get<ApiResponse<ResponseInterface>>(url, { params: JSON.parse(param) })
      .then(({ data }) => data.data)
  );
  return {
    ...output,
    isLoading: !output.error && !output.data,
  };
};

export default useAllKlhk;
